import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, Autoplay, Thumbs, FreeMode, Mousewheel } from 'swiper/modules';

function tablesSlider(tableThumbsEl, tableSliderSelector) {

  const rankingTablesConfig = {
    modules: [Navigation, Pagination, Keyboard, Autoplay, Mousewheel, Thumbs],
    direction: 'horizontal',
    spaceBetween: 25,
    loop: false,
    loopAdditionalSlides: 0,
    autoHeight: true,
    slidesPerView: 1,

    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        direction: 'vertical',
        mousewheel: {
          enabled: true,
          sensitivity: 2,
          releaseOnEdges: true,
          eventsTarget: '.swiper.mySwiper'
        },
      },
    },
    on: {
      init: function () {
        adjustSlideHeight(this); // Initial adjustment when Swiper is initialized
      },
      slideChange: function () {
        adjustSlideHeight(this); // Adjust height on slide change
      },
    },
  }

  if (document.querySelector(tableSliderSelector)) {

    const thmbsSwiper = new Swiper(tableThumbsEl, {
      modules: [FreeMode],
      spaceBetween: 0,
      direction: 'horizontal',
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        922: {
          direction: 'vertical',
        },
      },
    });

    rankingTablesConfig.thumbs = {
      swiper: thmbsSwiper,
    }

    const rankingTablesSwiper = new Swiper(tableSliderSelector, rankingTablesConfig);

    return rankingTablesSwiper
  }
  return
}

function checkSlideEdges(swiperInstance) {
  const isFirst = swiperInstance.isBeginning;
  const isLast = swiperInstance.isEnd;

  if (isFirst || isLast) {
    setTimeout(() => {
      swiperInstance.params.mousewheel.releaseOnEdges = true;
    }, 2000);
  } else {
    swiperInstance.params.mousewheel.releaseOnEdges = false;
    console.log('Not the edge');
  }
}

// Function to adjust Swiper container height based on active slide
function adjustSlideHeight(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex]; // Get the active slide
  const slideHeight = activeSlide.firstElementChild.offsetHeight;  // Get the height of the active slide

  swiper.el.style.height = `${slideHeight}px`; // Set the height of the container
  swiper.update(); // Force an update to apply the new height
}

function getTablesByCategory(catID) {

  fetch(`/rankings/pillar/getRankingsCategory?category=${catID}`, {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    }
  })
    .then(response => response.json())
    .then(function (result) {

      document.querySelector('.tab-content').innerHTML = result.html;
      tablesSlider('.mySwiper2', '.mySwiper');

    })
    .catch(function (error) {
      console.log(error)
    });
}

function rankingCategoriesTabs() {

  const tabsArray = Array.from(document.querySelectorAll('[data-category-tab]'));

  tabsArray.forEach(tab => {
    tab.addEventListener('click', function (e) {

      const catID = this.getAttribute('data-category-id');

      tabsArray.forEach(tab => tab.classList.add('grey'))
      this.classList.remove('grey');
      getTablesByCategory(catID);
    })
  })

}



document.addEventListener("DOMContentLoaded", () => {
  getTablesByCategory(document.querySelector('[data-category-tab]').getAttribute('data-category-id'));
  rankingCategoriesTabs();
})